var slice = require('../array/virtual/slice');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.slice;
  return it === ArrayPrototype || it instanceof Array && own === ArrayPrototype.slice ? slice : own;
};